export default __webpack_public_path__ + "static/media/Messages.01342eb9.svg";